import { parseImageFromFile } from "@faro-lotv/flat-ui";
import { UploadedFileData } from "@faro-lotv/service-wires";

type FileWithUploadedData = {
  file: File;
  uploadedFileData: UploadedFileData;
  thumbnailUri: string;
};

/**
 * @returns Grouped image files by their heuristic image type (360 or 2D). #
 * The assumption is that an image with aspect ratio 2:1 is an equirectangular 360 image.
 * @param files The files to be grouped
 * @param uploadedFilesData The uploaded data corresponding to the files
 * @param thumbnailUris The thumbnail URIs corresponding to the files
 */
export async function groupImageFilesByHeuristic(
  files: File[],
  uploadedFilesData: UploadedFileData[],
  thumbnailUris: string[],
): Promise<{
  img360s: FileWithUploadedData[];
  img2ds: FileWithUploadedData[];
}> {
  const img360s: FileWithUploadedData[] = [];

  const img2ds: FileWithUploadedData[] = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const uploadedFileData = uploadedFilesData[i];
    const thumbnailUri = thumbnailUris[i];

    const { width, height } = await parseImageFromFile(file);
    if (width === 2 * height) {
      img360s.push({ file, uploadedFileData, thumbnailUri });
    } else {
      img2ds.push({ file, uploadedFileData, thumbnailUri });
    }
  }

  return {
    img360s,
    img2ds,
  };
}
